/**
 * @desc 店铺关系关联表-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlatformSiteShopRelevanceResponseDto>
>;
export function request(
  params: API.basics.platformSiteShopRelevance.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShopPlatformSiteShopController/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
